import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Field,
  Input,
  PageHeader,
} from "../../design-system";
import { Icon } from "../../design-system/Icon";
import {
  clearStoredToken,
  getStoredToken,
  makeInspectionAxios,
  setStoredToken,
} from "./useInspectionPortal";

export default function PortalLogin() {
  document.title = "Acceso Inspección | Kronaly";
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Si ya hay token guardado y es válido, salta directo al dashboard.
  useEffect(() => {
    const existing = getStoredToken();
    if (!existing) return;
    const http = makeInspectionAxios(existing);
    http
      .get("/inspection/workspace")
      .then(() => navigate("/inspeccion/dashboard", { replace: true }))
      .catch(() => clearStoredToken());
  }, [navigate]);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!token.trim()) return;
    setError(null);
    setLoading(true);
    try {
      const http = makeInspectionAxios(token.trim());
      await http.get("/inspection/workspace");
      setStoredToken(token.trim());
      navigate("/inspeccion/dashboard", { replace: true });
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        setError("Token inválido, expirado o revocado. Solicita uno nuevo al responsable del workspace.");
      } else {
        setError(err?.response?.data?.error?.message || err?.message || "No se pudo validar el token.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--kr-bg-app, #f6f7f9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div style={{ width: "100%", maxWidth: 560 }}>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <Icon name="Shield" size={36} color="var(--kr-primary-600, #4f46e5)" />
        </div>

        <PageHeader
          eyebrow="Inspección de Trabajo"
          title="Acceso al registro horario"
          description="Introduce el token que te ha entregado el responsable del workspace. La autenticación se realiza únicamente mediante este token — no necesitas usuario ni contraseña."
        />

        <Card>
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <Field
              label="Token de Inspección"
              required
              description="Empieza por kins_. Si lo perdiste, solicita uno nuevo al responsable — no se pueden recuperar."
            >
              <Input
                type="password"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="kins_…"
                autoFocus
                autoComplete="off"
              />
            </Field>

            {error && <Alert tone="danger">{error}</Alert>}

            <div>
              <Button
                type="submit"
                variant="primary"
                icon="ArrowRight"
                disabled={!token.trim() || loading}
              >
                {loading ? "Validando…" : "Entrar"}
              </Button>
            </div>
          </form>
        </Card>

        <div style={{ marginTop: 16, textAlign: "center" }}>
          <a
            href="/inspeccion/verificar"
            style={{ fontSize: 13, color: "var(--kr-fg-muted)" }}
          >
            ¿Solo necesitas verificar un export descargado? →
          </a>
        </div>
      </div>
    </div>
  );
}
